import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

export type UseTrackingNumberRedirect = () => void;

export const useTrackingNumberRedirect: UseTrackingNumberRedirect = () => {
  const history = useHistory();

  useEffect(() => {
    const checkAndRedirect = () => {
      // Get the current URL search
      const currentSearch = history.location.search;

      // Check if the search contains the pattern ?trackingNumber=xxx
      const trackingNumberMatch = currentSearch.match(/[?&]trackingNumber=([^&]+)/);

      if (trackingNumberMatch && trackingNumberMatch[1]) {
        const trackingNumber = decodeURIComponent(trackingNumberMatch[1]);
        // Redirect to the detail page with the tracking number
        history.replace(`/detail/${trackingNumber}`);
      }
    };

    checkAndRedirect();
  }, []); // Empty dependency array ensures this only runs once when component mounts
};
